export default {
  object: ['status'],
  array: ['index', 'hubName', 'moduleName', 'permission', 'type', 'roleLimit'],
};
